import PATHS from './paths';

const REGIONS = {
  US: PATHS.US_BASE,
  CN: PATHS.CN_BASE,
  AE_AR: '/ae_ar',
  AE_EN: '/ae_en'
};

// Returns a path prefixed by a designated region, default US.
function getRegionPath(path, region) {
  if (region === REGIONS.CN) {
    return `${PATHS.CN_BASE}${path}`;
  }
  if (region === REGIONS.AE_AR) {
    return `${REGIONS.AE_AR}${path}`;
  }
  if (region === REGIONS.AE_EN) {
    return `${REGIONS.AE_EN}${path}`;
  }

  return `${PATHS.US_BASE}${path}`;
}

// Returns a path in the same region as the current url.
// Replace the dynamic params with provided values, if applicable
function getSameRegionPath(path, params, qsParams) {
  // pathname gives '/ae_en/MyFF' from 'http://example.com/ae_en/MyFF'
  const { pathname } = window.location;
  const pathArray = pathname.split('/').filter(Boolean); // Remove empty strings
  let prefix;

  if (pathArray.length > 0) {
    // First element after split is the locale (e.g., 'us', 'cn', 'ae_ar', 'ae_en')
    const locale = `/${pathArray[0]}`;
    
    // Check if it's a valid region
    if (Object.values(REGIONS).includes(locale)) {
      prefix = locale;
    } else {
      prefix = PATHS.US_BASE; // Default to US
    }
  } else {
    prefix = PATHS.US_BASE; // Default to US
  }

  let regionPath = `${prefix}${path}`;

  if (params) {
    Object.keys(params).forEach((k) => {
      regionPath = regionPath.replace(`:${k}`, params[k]);
    });
  }

  if(qsParams){
    regionPath += '?';
    Object.keys(qsParams).forEach((k) => {
      if(qsParams[k] !== undefined && qsParams[k] !== null){
        regionPath += `${k}=${qsParams[k]}&`;
      }
    });
    regionPath = regionPath.slice(0, regionPath.length - 1); 
  }

  return regionPath;
}

function isAppOnly() {
  if (typeof window === 'undefined') return false;

  const searchParams = new URLSearchParams(window.location.search);

  return searchParams.get('APPONLY') === '1';
}

export {
  getRegionPath,
  getSameRegionPath,
  isAppOnly,
  REGIONS
};
